import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics/events";
import { type LocationState } from "history";
import pluralize from "pluralize";

import { Button } from "../../components/Button";
import {
  getWorkplacePlacementsPath,
  type WorkplacePlacementsPathSource,
} from "../../Placements/paths";

interface ViewStaffJobsButtonProps {
  workplaceId: string;
  source: WorkplacePlacementsPathSource;
  placementsCount: number;
  hasMorePlacements?: boolean;
  placementCandidateId: string | undefined;
  locationState: LocationState;
  variant?: "contained" | "outlined";
}

export function ViewStaffJobsButton(props: ViewStaffJobsButtonProps) {
  const {
    workplaceId,
    source,
    placementsCount,
    hasMorePlacements = false,
    placementCandidateId,
    locationState,
    variant = "outlined",
  } = props;

  // If there's a next page we only have a lower bound on the true count, so
  // show "N+" and pluralize unconditionally (the count will always be ≥ the
  // fetched page size when hasMorePlacements is true).
  const countLabel = hasMorePlacements ? `${placementsCount}+` : `${placementsCount}`;
  const jobsLabel = pluralize("job", hasMorePlacements ? 2 : placementsCount);

  return (
    <Button
      fullWidth
      variant={variant}
      href={getWorkplacePlacementsPath(workplaceId, source)}
      locationState={locationState}
      sx={(theme) => ({
        // !important is needed to override the default `box-shadow: none` on the button
        boxShadow: `${theme.shadows[3]} !important`,
      })}
      onClick={() => {
        logEvent(APP_V2_APP_EVENTS.PLACEMENT_WORKPLACE_AD_CARD_CLICKED, {
          workplaceId,
          placementCandidateId,
          openJobsCount: placementsCount,
        });
      }}
    >
      View {countLabel} staff {jobsLabel}
    </Button>
  );
}
